import { LogRequestStatus } from "generated-interfaces/graphql";

export const LOG_REQUEST_IN_PROGRESS_STATUSES = [
    LogRequestStatus.LogUploadInProgress,
    LogRequestStatus.LogUploadSuccessful,
    LogRequestStatus.NotIntiated,
    LogRequestStatus.ProcessingUploadedLogs,
];

export const LOG_REQUEST_COMPLETED_STATUSES = [
    LogRequestStatus.Successful,
    LogRequestStatus.LogUploadFailed,
    LogRequestStatus.ProcessingUploadedLogsFailed,
];
